/* ==========================================================================
   BrandSneakersEG — theme behaviours
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP';
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + fmt;
  };

  var lockScroll = function (on) {
    document.body.style.overflow = on ? 'hidden' : '';
  };

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  };

  // Strings come from data attributes on <body> so they stay translatable.
  var T = (function () {
    var d = document.body.dataset;
    return {
      addToCart: d.tAddToCart || 'Add to cart',
      buyNow: d.tBuyNow || 'Buy it now',
      soldOut: d.tSoldOut || 'Sold out',
      chooseSize: d.tChooseSize || 'Select a size',
      viewDetails: d.tViewDetails || 'View full details',
      remove: d.tRemove || 'Remove',
      noResults: d.tNoResults || 'No products found',
      viewAllResults: d.tViewAll || 'View all results'
    };
  })();

  /* ==========================================================================
     Shared variant picker — used by Quick View and the Wishlist.
     Nothing is preselected: a size must be chosen before either button works.
     ========================================================================== */
  function isDefaultOnly(p) {
    return p.variants.length === 1 && p.variants[0].title === 'Default Title';
  }

  function priceHTML(variant, p) {
    var v = variant || p.variants[0];
    var was = v.compare_at_price && v.compare_at_price > v.price;
    return money(v.price) + (was ? '<s>' + money(v.compare_at_price) + '</s>' : '');
  }

  function pickerHTML(p, ns) {
    if (isDefaultOnly(p)) {
      return '<input type="hidden" name="id" value="' + p.variants[0].id + '" data-variant-id>';
    }

    var names = (p.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });

    var groups = names
      .map(function (name, oi) {
        var values = [];
        p.variants.forEach(function (v) {
          if (values.indexOf(v.options[oi]) === -1) values.push(v.options[oi]);
        });

        var chips = values
          .map(function (val, vi) {
            var sellable = p.variants.some(function (v) {
              return v.options[oi] === val && v.available;
            });
            var id = ns + '-' + p.id + '-opt-' + oi + '-' + vi;
            return (
              '<input type="radio" id="' + id + '" name="' + ns + '-' + p.id + '-option-' + oi + '"' +
              ' value="' + esc(val) + '"' + (sellable ? '' : ' disabled') + ' hidden>' +
              '<label for="' + id + '" class="product-option__chip' +
              (sellable ? '' : ' is-unavailable') + '">' + val + '</label>'
            );
          })
          .join('');

        return (
          '<div class="product-option" data-option-index="' + oi + '">' +
          '<span class="product-option__label">' + name + '</span>' +
          '<div class="product-option__values">' + chips + '</div>' +
          '</div>'
        );
      })
      .join('');

    return groups + '<input type="hidden" name="id" value="" data-variant-id>';
  }

  function buyButtonsHTML() {
    return (
      '<div class="variant-actions">' +
      '<button type="submit" name="add" class="btn btn--navy btn--block" data-add disabled>' +
      '<span>' + T.chooseSize + '</span></button>' +
      '<button type="button" class="btn btn--gold btn--block" data-buy disabled>' +
      '<span>' + T.chooseSize + '</span></button>' +
      '</div>'
    );
  }

  // Wires a scope containing pickerHTML + buyButtonsHTML. Returns a getter for
  // the currently selected variant (null until every option is chosen).
  function wirePicker(scope, p) {
    if (!scope) return function () { return null; };

    var idField = scope.querySelector('[data-variant-id]');
    var addBtn = scope.querySelector('[data-add]');
    var buyBtn = scope.querySelector('[data-buy]');
    var priceEl = (scope.closest('[data-wl-item]') || scope.parentNode).querySelector('[data-price]');

    function current() {
      if (isDefaultOnly(p)) return p.variants[0];

      var chosen = [];
      var complete = true;
      scope.querySelectorAll('[data-option-index]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        if (c) chosen.push(c.value);
        else complete = false;
      });
      if (!complete) return null;

      return (
        p.variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        }) || null
      );
    }

    function sync() {
      var v = current();
      if (idField) idField.value = v ? v.id : '';

      [addBtn, buyBtn].forEach(function (b) {
        if (!b) return;
        var label = b.querySelector('span');
        if (!v) {
          b.disabled = true;
          if (label) label.textContent = T.chooseSize;
        } else if (!v.available) {
          b.disabled = true;
          if (label) label.textContent = T.soldOut;
        } else {
          b.disabled = false;
          if (label) label.textContent = b === buyBtn ? T.buyNow : T.addToCart;
        }
      });

      if (priceEl && v) priceEl.innerHTML = priceHTML(v, p);
    }

    scope.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', sync);
    });

    // Buy now: add the chosen variant, then go straight to checkout.
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var v = current();
        if (!v || !v.available) return;
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    sync();
    return current;
  }

  /* ==========================================================================
     Wishlist — stored in the browser, no account needed.
     ========================================================================== */
  var WL_KEY = 'bseg_wishlist';

  function wlGet() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
  }
  function wlSave(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) { /* storage full/blocked */ }
    wlSyncUI();
  }
  function wlToggle(handle) {
    var list = wlGet();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    wlSave(list);
    return list.indexOf(handle) > -1;
  }
  function wlSyncUI() {
    var list = wlGet();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wishlistToggle) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    wlToggle(btn.dataset.wishlistToggle);
  });

  wlSyncUI();

  /* ---------------- Wishlist rendering (drawer + page) ---------------- */
  // Fills a container with the saved products, each with sizes, Add to cart
  // and Buy now. Used by both the header drawer and the wishlist page.
  function wlRenderInto(container, emptyEl, ns) {
    if (!container) return;
    var handles = wlGet();

    var showEmpty = function () {
      container.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
    };

    if (!handles.length) return showEmpty();
    if (emptyEl) emptyEl.hidden = true;

    return Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var items = products.filter(Boolean);
      if (!items.length) return showEmpty();

      container.innerHTML =
        '<div class="wl-list">' +
        items
          .map(function (p) {
            var img = p.featured_image
              ? '<img src="' + p.featured_image + '" alt="' + esc(p.title) + '" width="300" height="300" loading="lazy">'
              : '';
            return (
              '<div class="wl-item" data-wl-item data-handle="' + esc(p.handle) + '">' +
              '<a class="wl-item__media" href="/products/' + p.handle + '">' + img + '</a>' +
              '<div class="wl-item__info">' +
              '<a class="wl-item__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
              '<p class="wl-item__price" data-price>' + priceHTML(p.variants[0], p) + '</p>' +
              '<form action="/cart/add" method="post" data-variant-form>' +
              pickerHTML(p, ns) +
              buyButtonsHTML() +
              '</form>' +
              '<button type="button" class="wl-item__remove" data-wishlist-toggle="' + esc(p.handle) + '">' +
              T.remove + '</button>' +
              '</div></div>'
            );
          })
          .join('') +
        '</div>';

      var forms = container.querySelectorAll('[data-variant-form]');
      items.forEach(function (p, i) { wirePicker(forms[i], p); });

      bindCartForms(container);
      wlSyncUI();
    });
  }

  var wlPage = document.querySelector('[data-wishlist-page]');
  var wlPageEmpty = document.querySelector('[data-wishlist-empty]');
  var wlDrawer = document.querySelector('[data-wl-drawer]');
  var wlDrawerBody = document.querySelector('[data-wl-drawer-body]');
  var wlDrawerEmpty = document.querySelector('[data-wl-drawer-empty]');

  function wlRenderAll() {
    if (wlPage) wlRenderInto(wlPage, wlPageEmpty, 'wlp');
    if (wlDrawer && !wlDrawer.hidden) wlRenderInto(wlDrawerBody, wlDrawerEmpty, 'wld');
  }

  // Keep every open view in step with the stored list, including other tabs.
  var wlSaveBase = wlSave;
  wlSave = function (list) { wlSaveBase(list); wlRenderAll(); };
  window.addEventListener('storage', function (e) { if (e.key === WL_KEY) wlRenderAll(); });

  if (wlDrawer) {
    var toggleWlDrawer = function (open) {
      wlDrawer.hidden = !open;
      lockScroll(open);
      if (open) wlRenderInto(wlDrawerBody, wlDrawerEmpty, 'wld');
    };
    document.querySelectorAll('[data-wl-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        toggleWlDrawer(true);
      });
    });
    document.querySelectorAll('[data-wl-close]').forEach(function (b) {
      b.addEventListener('click', function () { toggleWlDrawer(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggleWlDrawer(false);
    });
  }

  if (wlPage) wlRenderInto(wlPage, wlPageEmpty, 'wlp');

  /* ==========================================================================
     Cart drawer
     ========================================================================== */
  var cdRoot = document.querySelector('[data-cart-drawer]');
  if (cdRoot) {
    var cdBody = cdRoot.querySelector('[data-cart-drawer-body]');
    var cdEmpty = cdRoot.querySelector('[data-cart-drawer-empty]');
    var cdFoot = cdRoot.querySelector('[data-cart-drawer-foot]');
    var cdSubtotal = cdRoot.querySelector('[data-cart-subtotal]');

    var cdRender = function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });

      if (!cart.items.length) {
        cdBody.innerHTML = '';
        if (cdEmpty) cdEmpty.hidden = false;
        if (cdFoot) cdFoot.hidden = true;
        return;
      }
      if (cdEmpty) cdEmpty.hidden = true;
      if (cdFoot) cdFoot.hidden = false;
      if (cdSubtotal) cdSubtotal.textContent = money(cart.total_price);

      cdBody.innerHTML = cart.items
        .map(function (item) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + esc(item.product_title) + '" width="150" height="150" loading="lazy">'
            : '';
          var variant =
            item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="cd__variant">' + item.variant_title + '</p>'
              : '';
          return (
            '<div class="cd__item" data-key="' + esc(item.key) + '">' +
            '<a class="cd__media" href="' + item.url + '">' + img + '</a>' +
            '<div class="cd__info">' +
            '<a class="cd__name" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<p class="cd__price">' + money(item.final_line_price) + '</p>' +
            '<div class="cd__qty">' +
            '<button type="button" data-cd-step="-1" aria-label="minus">&minus;</button>' +
            '<span data-cd-qty>' + item.quantity + '</span>' +
            '<button type="button" data-cd-step="1" aria-label="plus">+</button>' +
            '</div>' +
            '</div>' +
            '<button type="button" class="cd__remove" data-cd-remove>' + T.remove + '</button>' +
            '</div>'
          );
        })
        .join('');
    };

    var cdFetch = function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(cdRender)
        .catch(function () { cdBody.innerHTML = ''; });
    };

    var cdChange = function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(cdRender)
        .catch(function () { /* leave the drawer as it was */ });
    };

    cdBody.addEventListener('click', function (e) {
      var row = e.target.closest('[data-key]');
      if (!row) return;
      var key = row.dataset.key;

      if (e.target.closest('[data-cd-remove]')) {
        cdChange(key, 0);
        return;
      }
      var step = e.target.closest('[data-cd-step]');
      if (step) {
        var now = parseInt(row.querySelector('[data-cd-qty]').textContent, 10) || 1;
        cdChange(key, Math.max(0, now + parseInt(step.dataset.cdStep, 10)));
      }
    });

    var toggleCart = function (open) {
      cdRoot.hidden = !open;
      lockScroll(open);
      if (open) cdFetch();
    };

    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        toggleCart(true);
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () { toggleCart(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggleCart(false);
    });

    window.__openCartDrawer = function () { toggleCart(true); };
  }

  /* ---------------- Mobile menu ---------------- */
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  function toggleMenu(open) {
    if (!menuDrawer) return;
    menuDrawer.hidden = !open;
    lockScroll(open);
  }
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { toggleMenu(true); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { toggleMenu(false); });
  });

  /* ---------------- Mobile drawer tabs ---------------- */
  if (menuDrawer) {
    var drawerTabs = menuDrawer.querySelectorAll('[data-drawer-tab]');
    var drawerPanes = menuDrawer.querySelectorAll('[data-drawer-pane]');
    drawerTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.drawerTab;
        drawerTabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        drawerPanes.forEach(function (p) {
          var on = p.dataset.drawerPane === key;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
        });
      });
    });
  }

  /* ---------------- Search drawer ---------------- */
  var searchDrawer = document.querySelector('[data-search-drawer]');
  function toggleSearch(open) {
    if (!searchDrawer) return;
    searchDrawer.hidden = !open;
    if (open) {
      var i = searchDrawer.querySelector('input');
      if (i) i.focus();
    }
  }
  document.querySelectorAll('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () { toggleSearch(true); });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (b) {
    b.addEventListener('click', function () { toggleSearch(false); });
  });

  /* ---------------- Live search suggestions ---------------- */
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');

  if (searchInput && searchResults) {
    var searchTimer = null;
    var lastQuery = '';
    var searchSeq = 0;

    var renderSuggestions = function (products, query) {
      if (!products.length) {
        searchResults.innerHTML =
          '<p class="search-suggest__empty">' + T.noResults + '</p>';
        searchResults.hidden = false;
        return;
      }

      searchResults.innerHTML =
        '<ul class="search-suggest__list" role="list">' +
        products
          .map(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy">'
              : '<span class="search-suggest__ph"></span>';
            // price comes back as a decimal string on the suggest endpoint
            var price = p.price != null ? money(Math.round(parseFloat(p.price) * 100)) : '';
            return (
              '<li><a class="search-suggest__item" href="' + p.url + '">' +
              '<span class="search-suggest__media">' + img + '</span>' +
              '<span class="search-suggest__text">' +
              '<span class="search-suggest__title">' + p.title + '</span>' +
              (price ? '<span class="search-suggest__price">' + price + '</span>' : '') +
              '</span></a></li>'
            );
          })
          .join('') +
        '</ul>' +
        '<a class="search-suggest__all" href="/search?q=' + encodeURIComponent(query) + '">' +
        T.viewAllResults + '</a>';

      searchResults.hidden = false;
    };

    var runSearch = function (raw) {
      // The suggest endpoint matches case-insensitively; just trim the input.
      var query = raw.trim();

      if (query.length < 2) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
        lastQuery = '';
        return;
      }
      if (query === lastQuery) return;
      lastQuery = query;

      var seq = ++searchSeq;
      var url =
        '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku,tag';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Ignore responses that arrive after a newer keystroke.
          if (seq !== searchSeq) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSuggestions(products, query);
        })
        .catch(function () {
          if (seq !== searchSeq) return;
          searchResults.hidden = true;
        });
    };

    searchInput.addEventListener('input', function () {
      var value = searchInput.value;
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () { runSearch(value); }, 220);
    });

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length >= 2 && searchResults.innerHTML) searchResults.hidden = false;
    });

    // Clicking outside the drawer closes the suggestions.
    document.addEventListener('click', function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) {
        searchResults.hidden = true;
      }
    });
  }

  /* ---------------- Tabs ---------------- */
  // Elements inside a hidden panel never intersect, so the scroll-reveal
  // observer never fires for them. Reveal them explicitly on tab switch.
  function revealWithin(el) {
    el.querySelectorAll('.reveal').forEach(function (r) { r.classList.add('is-visible'); });
  }

  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var btns = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.tabBtn;
        btns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.tabPanel === idx;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
          if (on) revealWithin(p);
        });
      });
    });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-product-media]').forEach(function (gallery) {
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.dataset.thumb;
        gallery.querySelectorAll('[data-media-id]').forEach(function (m) {
          m.classList.toggle('is-active', m.dataset.mediaId === id);
        });
        gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  });

  /* ---------------- Variant picker ---------------- */
  var form = document.getElementById('product-form');
  if (form) {
    var dataEl = document.querySelector('[data-product-json]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* no variant data */ }
    var select = form.querySelector('[data-variant-select]');
    var addButton = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-product-price]');

    var updateVariant = function () {
      var selected = [];
      form.querySelectorAll('.product-option').forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) selected.push(checked.value);
      });
      if (!selected.length) return;

      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;

      if (select) select.value = match.id;
      if (addButton) {
        addButton.disabled = !match.available;
        var label = addButton.querySelector('span');
        if (label) label.textContent = match.available ? label.dataset.addText : label.dataset.soldText;
      }
      if (priceEl) {
        var html = '<span class="product-info__price-now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s>' + money(match.compare_at_price) + '</s>';
          priceEl.classList.add('product-info__price--sale');
        } else {
          priceEl.classList.remove('product-info__price--sale');
        }
        priceEl.innerHTML = html;
      }
    };

    form.querySelectorAll('input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', updateVariant);
    });
  }

  /* ---------------- Async add to cart ---------------- */
  function bindCartForms(scope) {
    (scope || document).querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.dataset.cartBound) return;
      f.dataset.cartBound = '1';
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return; // fall back to a normal POST
        e.preventDefault();
        var btn = f.querySelector('button[name="add"]');
        var span = btn && btn.querySelector('span');
        var original = span ? span.textContent : '';
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(f),
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (btn) btn.disabled = false;
            if (span) {
              span.textContent = '✓';
              setTimeout(function () { span.textContent = original; }, 1200);
            }
            if (typeof window.__openCartDrawer === 'function') window.__openCartDrawer();
          })
          .catch(function () { f.submit(); });
      });
    });
  }
  bindCartForms();

  /* ---------------- Buy now (straight to checkout) ---------------- */
  var buyNow = document.querySelector('[data-buy-now]');
  if (buyNow && form) {
    buyNow.addEventListener('click', function () {
      if (!window.fetch) {
        form.submit();
        return;
      }
      buyNow.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNow.disabled = false;
          form.submit();
        });
    });
  }

  /* ---------------- Share: copy link ---------------- */
  document.querySelectorAll('[data-share-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-share-url]');
      if (!wrap) return;
      var url = wrap.dataset.shareUrl;
      var toast = wrap.querySelector('[data-share-toast]');

      var done = function () {
        if (!toast) return;
        toast.hidden = false;
        clearTimeout(toast._t);
        toast._t = setTimeout(function () { toast.hidden = true; }, 1800);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(done);
      } else {
        var tmp = document.createElement('input');
        tmp.value = url;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); } catch (e) { /* nothing else to try */ }
        document.body.removeChild(tmp);
        done();
      }
    });
  });

  /* ---------------- Quick view ---------------- */
  var qv = document.querySelector('[data-qv]');
  var qvContent = qv && qv.querySelector('[data-qv-content]');

  function closeQv() {
    if (!qv) return;
    qv.hidden = true;
    lockScroll(false);
  }
  if (qv) {
    qv.querySelectorAll('[data-qv-close]').forEach(function (b) {
      b.addEventListener('click', closeQv);
    });
  }

  function renderQv(p) {
    var img = p.featured_image
      ? '<img src="' + p.featured_image + '" alt="' + esc(p.title) + '" width="600" height="600">'
      : '';

    qvContent.innerHTML =
      '<div class="qv__grid">' +
      '<div class="qv__media">' + img + '</div>' +
      '<div class="qv__info">' +
      '<h2 class="qv__title">' + p.title + '</h2>' +
      '<p class="qv__price" data-price>' + priceHTML(p.variants[0], p) + '</p>' +
      '<div class="qv__desc rte">' + (p.description || '') + '</div>' +
      '<form action="/cart/add" method="post" data-variant-form>' +
      pickerHTML(p, 'qv') +
      buyButtonsHTML() +
      '</form>' +
      '<a href="/products/' + p.handle + '" class="customer-page__link">' + T.viewDetails + '</a>' +
      '</div></div>';

    wirePicker(qvContent.querySelector('[data-variant-form]'), p);
    bindCartForms(qvContent);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view]');
    if (!trigger || !qv) return;
    e.preventDefault();
    e.stopPropagation();

    qv.hidden = false;
    lockScroll(true);
    qvContent.innerHTML = '<div class="qv__loading">…</div>';

    fetch('/products/' + trigger.dataset.quickView + '.js')
      .then(function (r) { return r.json(); })
      .then(renderQv)
      .catch(function () {
        qvContent.innerHTML = '<div class="qv__loading">Unable to load this product.</div>';
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    toggleSearch(false);
    toggleMenu(false);
    closeQv();
  });

  /* ---------------- Scroll reveal ---------------- */
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.section > .page-width, .bbanner, .pcard, .fcard');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    targets.forEach(function (el) {
      el.classList.add('reveal');
      io.observe(el);
    });
  }
})();
